import * as types from "./types";

export const getMyCompanyRequest = (payload) => ({
  type: types.GET_MY_COMPANY_REQUEST,
  payload,
});

export const getMyCompanySuccess = (payload) => ({
  type: types.GET_MY_COMPANY_SUCCESS,
  payload,
});

export const getMyCompanyFailure = (payload) => ({
  type: types.GET_MY_COMPANY_FAILURE,
  payload,
});

export const clearMyCompany = () => ({
  type: types.CLEAR_MY_COMPANY,
});

export const clearMyCompanyActiveEditRequest = () => ({
  type: types.CLEAR_MY_COMPANY_ACTIVE_EDIT_REQUEST,
});
